var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isPlannerPage
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "mb-2 d-flex quick-select" },
                [
                  _c("v-select", {
                    staticClass: "pr-2 pl-2",
                    attrs: {
                      items: _vm.yearOptions,
                      label: "Year",
                      "item-text": "text",
                      "item-value": "value",
                    },
                    model: {
                      value: _vm.selectedYear,
                      callback: function ($$v) {
                        _vm.selectedYear = $$v
                      },
                      expression: "selectedYear",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "pr-2 pl-2",
                    attrs: {
                      items: _vm.monthOptions,
                      label: "Month",
                      "item-text": "text",
                      "item-value": "value",
                    },
                    model: {
                      value: _vm.selectedMonth,
                      callback: function ($$v) {
                        _vm.selectedMonth = $$v
                      },
                      expression: "selectedMonth",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "lime mt-2 ml-2 mr-4",
                      on: {
                        click: function ($event) {
                          return _vm.setSelectedDateByForm()
                        },
                      },
                    },
                    [_vm._v("Go")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-card", { staticClass: "mb-4" }, [
        _c(
          "div",
          { staticClass: "month-controls" },
          [
            _c(
              "v-btn",
              {
                staticStyle: { height: "auto" },
                on: {
                  click: function ($event) {
                    return _vm.subMonthFromSelectedDate()
                  },
                },
              },
              [_c("v-icon", [_vm._v("keyboard_arrow_left")])],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  "justify-items": "space-between",
                },
              },
              [
                _c("div", [_vm._v("Availability")]),
                _vm._v(" "),
                _c("div", [_vm._v(" ")]),
                _vm._v(" "),
                _c("div", [_vm._v("Rates")]),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.visibleMonths, function (month, index) {
              return _c("span", { key: index }, [
                _c(
                  "div",
                  [
                    !month.isMissingRates
                      ? _c(
                          "v-icon",
                          {
                            attrs: {
                              title: "All rates entered for month",
                              color: "green",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    check_circle\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    month.isMissingRates
                      ? _c(
                          "v-icon",
                          {
                            attrs: {
                              title: "Some rates missing for month",
                              color: "orange",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    warning\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    style: {
                      color: "black !important",
                      "font-weight": _vm.monthIsSelected(month)
                        ? "bold"
                        : "normal",
                    },
                    attrs: { href: _vm.getMonthHref(month) },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedDateByIndex(month.index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(month.monthName) +
                        " " +
                        _vm._s(month.shortYear) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "available-percentage": month.hasAvailable,
                      "on-request-percentage":
                        !month.hasAvailable && month.hasOnRequest,
                      "closed-full-month-percentage": month.closedForFullMonth,
                      "none-available":
                        !month.hasAvailable &&
                        !month.hasOnRequest &&
                        !month.closedForFullMonth,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(month.eligibleRoomsPercentage) +
                        "% \n                "
                    ),
                  ]
                ),
              ])
            }),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticStyle: { height: "auto" },
                on: {
                  click: function ($event) {
                    return _vm.addMonthToSelectedDate()
                  },
                },
              },
              [_c("v-icon", [_vm._v("keyboard_arrow_right")])],
              1
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("strong", [_vm._v("Month Selector")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }